import * as React from 'react';

import styled from 'styled-components';

import { motion, useMotionValue, useTransform } from 'framer-motion';

export interface CircleCheckIconProps {
  className?: string;
  iconSize?: number;
  noAnimation?: boolean;
  dark?: boolean;
  customColor?: string;
  noCircle?: boolean;
  onClick?: (ev: React.MouseEvent<SVGSVGElement, MouseEvent>) => void;
}

export const CircleCheckIcon: React.FC<CircleCheckIconProps> = (props) => {
  const pathLength = useMotionValue(0);
  const opacity = useTransform(pathLength, [0.05, 0.15], [0, 1]);

  const path = {
    hidden: {
      pathLength: 0,
    },
    visible: {
      pathLength: 1,
      transition: {
        duration: 4,
        type: 'spring',
        stiffness: 50,
      },
    },
  };

  return (
    <svg
      className={props.className}
      onClick={(ev) => (props.onClick ? props.onClick(ev) : null)}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <motion.path
        className="path"
        strokeWidth="2"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeLinejoin="round"
        d="M8 12.1 10.9 15 16 10"
        initial={'hidden'}
        animate={'visible'}
        exit={'hidden'}
        variants={path}
        style={{ pathLength: pathLength, opacity: opacity }}
      />
      <motion.path
        className="circle"
        d="M1,12a11,11 0 1,0 22,0a11,11 0 1,0 -22,0"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeMiterlimit="10"
        initial={'hidden'}
        animate={'visible'}
        exit={'hidden'}
        variants={path}
        style={{ pathLength: pathLength, opacity: opacity }}
      />
    </svg>
  );
};

export default styled(CircleCheckIcon)`
  width: ${(props) => (props.iconSize ? props.iconSize : '32')}px;
  height: ${(props) => (props.iconSize ? props.iconSize : '32')}px;

  .path,
  .circle {
    fill: none;
    transition: stroke
      ${({ theme }) =>
        `${theme.transitions.duration} ${theme.transitions.type}`};
  }

  .path,
  .circle {
    stroke: ${({ theme }) => theme.colors.success};
  }

  ${(props) =>
    props.noAnimation
      ? `
      .path,
      .circle {
        opacity: 1;
        animation: none;
        stroke-dasharray: 0;
        stroke-dashoffset: 0;
      }
    `
      : null}

  ${(props) =>
    props.noCircle
      ? `
      .circle {
        display: none;
      }
  `
      : null}

  ${(props) =>
    props.customColor
      ? `
      .circle,
      .path {
        stroke: ${props.customColor};
      }
  `
      : null}
`;
